import script from "./AnalyticsNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsNavbar.vue?vue&type=script&setup=true&lang=js"

import "./AnalyticsNavbar.vue?vue&type=style&index=0&id=05b6789a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b6789a"]])

export default __exports__